<div class="account-balance-card">
  @if (!hasData) {
    <div class="u-flex-center">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>
  }
  @if (hasData) {
    <div class="account-balance-card_content">
      <h2 class="mat-display-medium u-text-heading_light-blue">
        {{
        accountDetails.accountBalance < 0 ? "Account Balance" : "Current balance due"
        }}
      </h2>
      <h1 class="mat-display-small mobile-change">
        &pound; {{ accountDetails ? accountDetails.accountBalance : "0.00" }}
      </h1>
    </div>
  }
</div>